import Header from "./Header";
import Footer from "./Footer";
import "./Frontpage.css";
import ConForm from "./ConForm";
import React from "react";
import img1 from "./img/IMG_20250326_161654_145.jpg";
import pak1 from "./img/pak1.jpg";
import pak2 from "./img/pak2.jpg";


const LargeEquipment = () => {
    //!!! banner grid not working quite as intended !!!
    return (
        <div className="background">
            <Header/>
            <div className="rowDiv">
                <div className="bg-text">
                <div className="text-container-grid">
                    {/* <div className="slogan">Vuokraa laitteet tapahtumaasi Luminarylta!</div> */}
                    <br/>
                    <div className="textblock">Yrityksille tarjoamme laadukasta vuokralaitteistoa myös suuriin tapahtumiin. Meiltä saat kattavat tekniset ratkaisut ääni- ja valotekniikkaan, räätälöitynä juuri tarpeidesi mukaan. 
                    Varmistamme saumattoman toteutuksen ja ikimuistoisen elämyksen yleisöllesi.
                        <br/>
                        <br/>
                        Ammattitaitoiset ääni- ja valoteknikkomme huolehtivat, että kaikki sujuu täydellisesti.
                        <br/>
                        
                    </div>
                    <br/>
                    <div className="subquestion">Luodaan yhdessä vaikuttava tapahtuma!</div>
                </div>
                </div>
                <div className="image-container">
                    <img src={img1} width="500" alt="dj" className="LargeEquipmentImage"/>
                    </div>
            </div>
            <ConForm/>

            <Footer/>
        </div>
    );
};

export default LargeEquipment;
